module.exports = __webpack_public_path__ + "fonts/deposit-detail-guide-1.9d4fb753s.png";